import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import styles from './TemplateManager.module.css'
import { useNavigate, useLocation } from 'react-router-dom'
// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const TemplateManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current =passedData
        }
       
    }
    useEffect(() => {
        const interval = setInterval(() => checkClientEvent(), (300)) // run events fetch every .3 seconds
        return () => clearInterval(interval)
    }, [])
    const checkClientEvent = () => {
        // Update clientevent with every render when its value has changed.
        let savedClientEvent = clientEventService.getClientEvent()
        if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
            savedClientEvent && savedClientEvent.eventId!==undefined &&
            savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
            setClientEventInfo(savedClientEvent)
            clientEventInfoRef.current = savedClientEvent;
        }
    }

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Event Badges Template Management</h1><br />
            <h2>Control event badge template setup, using UI walkthrough.</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/EventBadgesTemplateManager`} className={styles.eventLinks}
                    state={clientEventInfo}
                    title="Create/edit badge templates - style, order, editing, etc.">
                    <h3>Use UI Walkthrough</h3>
                </Link>
                <Link to={`/FlatTemplateSetup`} className={styles.eventLinks}
                    state={clientEventInfo}
                    title="Create/edit flat template file.">
                    <h3>Use Flat File Template</h3>
                </Link>
                <Link to={`/CSHTMLConversionTemplateSetup`} className={styles.eventLinks}
                    title="Convert a legacy .cshtml badge view into a flat template file. (EXPERIMENTAL)">
                    <h3>Convert Legacy CSHTML<br/>Template - EXPERIMENTAL</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default TemplateManager;